import React from 'react';
import Icon from '../base/icons/components/Icon';
import { IconMic, IconMicBan, IconMicFill, IconMicSlashIncaditor, IconVideo, IconVideoBan, IconVideoFill, IconVideoOffIncaditor } from '../base/icons/svg';
/**
 * Reducer key for the feature.
 */
export const REDUCER_KEY = 'features/participants-pane';
/**
 * Enum of possible participant action triggers.
 */
export const ACTION_TRIGGER = {
    HOVER: 'Hover',
    PERMANENT: 'Permanent'
};
/**
 * Enum of possible participant media states.
 */
export const MEDIA_STATE = {
    DOMINANT_SPEAKER: 'DominantSpeaker',
    MUTED: 'Muted',
    FORCE_MUTED: 'ForceMuted',
    UNMUTED: 'Unmuted',
    NONE: 'None'
};
/**
 * Enum of possible participant mute button states.
 */
export const QUICK_ACTION_BUTTON = {
    ALLOW_VIDEO: 'AllowVideo',
    MUTE: 'Mute',
    ASK_TO_UNMUTE: 'AskToUnmute',
    NONE: 'None',
    STOP_VIDEO: 'StopVideo'
};
/**
 * Icon mapping for possible participant audio states.
 */
export const AudioStateIcons = {
    [MEDIA_STATE.DOMINANT_SPEAKER]: (React.createElement(Icon, { className: 'jitsi-icon-dominant-speaker', size: 16, src: IconMic })),
    [MEDIA_STATE.FORCE_MUTED]: (React.createElement(Icon, { color: '#E04757', size: 16, src: IconMicSlashIncaditor })),
    [MEDIA_STATE.MUTED]: (React.createElement(Icon, { size: 16, src: IconMicSlashIncaditor })),
    [MEDIA_STATE.UNMUTED]: (React.createElement(Icon, { size: 16, src: IconMic })),
    [MEDIA_STATE.NONE]: null
};
export const AudioPinkStateIcons = {
    ...AudioStateIcons,
    [MEDIA_STATE.UNMUTED]: (React.createElement(Icon, { className: 'jitsi-icon-pink', size: 16, src: IconMicFill })),
    [MEDIA_STATE.FORCE_MUTED]: (React.createElement(Icon, { size: 16, src: IconMicBan }))
};
/**
 * Icon mapping for possible participant video states.
 */
export const VideoStateIcons = {
    [MEDIA_STATE.DOMINANT_SPEAKER]: null,
    [MEDIA_STATE.FORCE_MUTED]: (React.createElement(Icon, { color: '#E04757', id: 'videoMuted', size: 16, src: IconVideoOffIncaditor })),
    [MEDIA_STATE.MUTED]: (React.createElement(Icon, { id: 'videoMuted', size: 16, src: IconVideoOffIncaditor })),
    [MEDIA_STATE.UNMUTED]: (React.createElement(Icon, { size: 16, src: IconVideo })),
    [MEDIA_STATE.NONE]: null
};
export const VideoPinkStateIcons = {
    ...VideoStateIcons,
    [MEDIA_STATE.UNMUTED]: (React.createElement(Icon, { className: 'jitsi-icon-pink', size: 16, src: IconVideoFill })),
    [MEDIA_STATE.FORCE_MUTED]: (React.createElement(Icon, { color: '#E04757', id: 'videoMuted', size: 16, src: IconVideoBan })),
};
/**
 * Mobile web context menu avatar size.
 */
export const AVATAR_SIZE = 32;
